import { render, staticRenderFns } from "./ProductMatchingMethodSelect.vue?vue&type=template&id=6761a22a&scoped=true"
import script from "./ProductMatchingMethodSelect.vue?vue&type=script&lang=ts"
export * from "./ProductMatchingMethodSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6761a22a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6761a22a')) {
      api.createRecord('6761a22a', component.options)
    } else {
      api.reload('6761a22a', component.options)
    }
    module.hot.accept("./ProductMatchingMethodSelect.vue?vue&type=template&id=6761a22a&scoped=true", function () {
      api.rerender('6761a22a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/price-lists/ProductMatchingMethodSelect.vue"
export default component.exports